






















































































import { Component, mixins, namespace, Prop } from 'nuxt-property-decorator'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import MixinGeneral from '~/assets/mixins/general'
import { ORDER_CREDIT_API, PRODUCTS_API } from '~/assets/config/api-path'
import {
  IProductAdditionalService,
  IProductCredit,
} from '~/assets/interfaces/products'
import { filterUrl } from '~/assets/filters/url'
import { PRIVACY_POLICY_PATH } from '~/assets/config/path'
import { IUser } from '~/assets/interfaces/user'
import ComponentFormInputText from '~/components/form/input-text.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentLoadingDots from '~/components/loading/dots.vue'
import ComponentImage from '~/components/images/image.vue'

const siteStore = namespace('site')
const cartStore = namespace('cart')
const authStore = namespace('auth')

@Component({
  components: {
    ComponentFormButton,
    ComponentLoadingDots,
    ComponentImage,
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentFormInputText,
    ComponentAlert: () => import('~/components/alerts/alert.vue'),
  },
  filters: {
    filterUrl,
  },
  mixins: [validationMixin],
  validations: {
    formDataPhone: {
      required,
      correct: (val) => !val.includes('_'),
    },
    formDataName: {
      required,
    },
    formDataEmail: {
      email,
    },
    formDataAddress: {
      required,
    },
  },
})
export default class ComponentProductCredits extends mixins(MixinGeneral) {
  @Prop({ type: Number, default: -1 }) readonly productId!: number
  @Prop({ type: Array, default: () => [] })
  readonly servicesForBuy!: IProductAdditionalService[]

  @siteStore.Getter('getOptionsPhoneMask') private getOptionsPhoneMask!: string
  @cartStore.Action('getItems') private getCartItems!: () => Promise<void>
  @authStore.State('user') private user!: IUser | null

  private items: IProductCredit[] = []
  private isLoading = false
  private isLoadingForm = false
  private isModal: null | IProductCredit = null
  private formDataPhone = ''
  private formDataName = ''
  private formDataEmail = ''
  private formDataAddress = ''
  private PRIVACY_POLICY_PATH = PRIVACY_POLICY_PATH
  private errorText: string | null = null

  private async created() {
    this.isLoading = true
    const response = await this.$axios.$get(
      PRODUCTS_API + '/' + this.productId + '/credits'
    )
    this.items = response.items
    this.isLoading = false

    if (this.user) {
      if (this.user.name) {
        this.formDataName = this.user.name
      }
      if (this.user.phone) {
        this.formDataPhone = this.user.phone
      }
      if (this.user.email) {
        this.formDataEmail = this.user.email
      }
    }
  }

  private doAction(item: IProductCredit) {
    if (item.url && item.type === 'link') {
      window.open(item.url, '_blank')
    }
    if (item.type === 'form') {
      this.isModal = item
    }
  }

  private styleButton(item: IProductCredit) {
    if (item.color && item.colorText) {
      return {
        background: item.color,
        color: item.colorText,
      }
    }
    return {}
  }

  private classButton(item: IProductCredit) {
    const base = {
      [this.$style.button]: true,
      [this.$style.customColor]: item.color && item.colorText,
    }
    return base
  }

  private get formData() {
    const tempServicesForBuy = this.servicesForBuy
      .filter((item) => item.active)
      .map((item) => {
        return {
          id: item.id,
        }
      })

    return {
      name: this.formDataName,
      phone: this.formDataPhone,
      email: this.formDataEmail,
      address: this.formDataAddress,
      productId: this.productId,
      creditId: this.isModal ? this.isModal.id : null,
      services: tempServicesForBuy,
    }
  }

  private async send() {
    if (!this.isLoadingForm) {
      this.errorText = null
      this.isLoadingForm = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const response = await this.$axios.$post(
          ORDER_CREDIT_API,
          this.formData
        )
        if (response.success) {
          window.open(response.url, '_blank')
          this.isModal = null
          await this.getCartItems()
        } else {
          this.errorText = response.text
        }
      }
      this.isLoadingForm = false
    }
  }
}
